import { Grid, TWO_COLUMN_MAX_WIDTH } from '@spotify-internal/frodor-modules';
import React from 'react';
import styled from 'styled-components';
import { SideBar } from './SideBar';
import { BlogPostPreview } from './BlogPostPreview';
import { useReduxBlog } from './useReduxBlog';
import { ButtonPrimary, cssSpacing } from '@spotify-internal/encore-web';
import { useTracking } from '../Tracking';
import { useT } from '@spotify-internal/i18n-core';
import { MAX_CONTENT_WIDTH } from '../constants';

const CategoryItems = styled.article`
  padding-top: ${cssSpacing('base')};
  grid-column: 1 / 9;
  display: flex;
  flex-direction: column;
  @media (max-width: ${TWO_COLUMN_MAX_WIDTH}) {
    grid-column: 1 / -1;
    padding-inline-end: 0;
  }
  padding-inline-end: ${cssSpacing('looser-6')};
  max-width: ${MAX_CONTENT_WIDTH};
`;
const StyledSideBar = styled(SideBar)`
  grid-column: 9 / 13;
  position: sticky;
  align-self: flex-start;
  top: 72px;
  padding-top: ${cssSpacing('base')};
  margin-bottom: 110px;
  @media (max-width: ${TWO_COLUMN_MAX_WIDTH}) {
    display: none;
  }
`;

const StyledGrid = styled(Grid)`
  padding-block-start: ${cssSpacing('looser-3')};
  padding-block-end: ${cssSpacing('looser-4')};

  position: relative;
`;

export const BlogSection = () => {
  const { blogPosts, blogCategories, loadMore, loadingMore } = useReduxBlog();
  const categorySlug = 'all';
  const category = blogCategories?.bySlug[categorySlug];
  const t = useT();
  const { eventHandler } = useTracking();

  return (
    <div className="encore-light-set">
      <StyledGrid>
        <CategoryItems>
          {category.items.map((id: string) => {
            const post = blogPosts.byId[id];
            return <BlogPostPreview key={id} blogPost={post} />;
          })}
          {category.items.length < category.total && (
            <ButtonPrimary
              onClick={e => {
                eventHandler('Blog Category', 'Load More')(e);
                loadMore(category);
              }}
              disabled={loadingMore}
            >
              {loadingMore
                ? t(
                    'FRODOR_0e2fe9',
                    'Loading...',
                    'Waiting for the loading process',
                  )
                : t('FRODOR_3fedd3', 'Load More', 'Attempt to load more data')}
            </ButtonPrimary>
          )}
        </CategoryItems>
        <StyledSideBar />
      </StyledGrid>
    </div>
  );
};
